import { Navigate, useLocation } from 'react-router-dom'
import { useLayoutEffect } from 'react'
import { savePostLoginRedirect } from '@/lib/auth/postLoginRedirect'

/**
 * Persists the attempted URL (sessionStorage) then sends the user to login.
 * Used for unauthenticated wildcard matches so deeplinks survive a full reload.
 */
export function UnauthenticatedRedirect() {
  const location = useLocation()

  useLayoutEffect(() => {
    savePostLoginRedirect(`${location.pathname}${location.search}${location.hash}`)
  }, [location])

  return <Navigate to="/login" replace state={{ from: location }} />
}
